(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
/* =====================================================
   BUNDLE SECTION JAVASCRIPT
   Compatible with Dawn theme cart drawer
   Supports per-product discounts
   ===================================================== */
(function () {
  'use strict';

  class BundleSection {
    constructor(container) {
      this.container   = container;
      this.sectionId   = container.dataset.sectionId;
      this.globalDiscountPct = parseFloat(container.dataset.globalDiscount) || 0;
      this.discountCode= container.dataset.discountCode || '';
      this.cards       = Array.from(container.querySelectorAll('[data-product-id]'));
      this.addBtn      = container.querySelector('#BundleAddToCart-' + this.sectionId);
      this.totalOrigEl = container.querySelector('.js-bundle-original-total');
      this.totalSaleEl = container.querySelector('.js-bundle-sale-total');
      this.savingsEl   = container.querySelector('.js-bundle-savings');

      /*
        lineItems keyed by productId:
        { variantId (integer), originalPrice (cents), finalPrice (cents), productDiscount (float) }
      */
      this.lineItems = {};

      this.init();
    }

    init() {
      this.cards.forEach(card => {
        const variantSelect = card.querySelector('.bundle-section__variant-select');
        if (variantSelect) {
          variantSelect.addEventListener('change', e => this.onVariantChange(card, e.target));
        }
        this.registerCard(card);
      });

      this.updateTotals();

      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => this.addBundleToCart());
      }
    }

    /* --------------------------------------------------
       Register a card's initial prices from Liquid attrs
    -------------------------------------------------- */
    registerCard(card) {
      const originalPrice = parseInt(card.dataset.originalPrice, 10) || 0;
      const finalPrice    = parseInt(card.dataset.finalPrice, 10)    || 0;
      const variantId     = parseInt(card.dataset.variantId, 10)     || 0;
      const productId     = card.dataset.productId;
      const productDiscount = parseFloat(card.dataset.productDiscount) || this.globalDiscountPct;

      if (!originalPrice || !variantId) return; // no product assigned yet

      // Update the displayed sale price in the card from Liquid-computed value
      const salePriceEl = card.querySelector('.bundle-section__sale-price');
      if (salePriceEl) salePriceEl.textContent = this.formatMoney(finalPrice);

      this.lineItems[productId] = { 
        variantId, 
        originalPrice, 
        finalPrice,
        productDiscount
      };
    }

    /* --------------------------------------------------
       On variant <select> change — fetch variant price
       then recalculate discount correctly using product-specific discount
    -------------------------------------------------- */
    onVariantChange(card, select) {
      const newVariantId = parseInt(select.value, 10);
      const productId    = card.dataset.productId;
      const productDiscount = parseFloat(card.dataset.productDiscount) || this.globalDiscountPct;

      /*
        First try: read the price from the <option data-price> attribute
        (fast, no network call). Fall back to product JSON fetch.
      */
      const selectedOption = select.options[select.selectedIndex];
      const optionPrice    = parseInt(selectedOption.dataset.price, 10);

      if (optionPrice) {
        this.applyVariantPrice(card, productId, newVariantId, optionPrice, productDiscount);
      } else {
        const handle = card.dataset.handle;
        if (!handle) return;

        fetch('/products/' + handle + '.js')
          .then(r => r.json())
          .then(data => {
            const variant = data.variants.find(v => v.id === newVariantId);
            if (!variant) return;
            this.applyVariantPrice(card, productId, newVariantId, variant.price, productDiscount);
          })
          .catch(err => console.warn('[Bundle] Variant fetch error', err));
      }
    }

    applyVariantPrice(card, productId, variantId, price, productDiscount) {
      const discount    = Math.round(price * productDiscount / 100);
      const finalPrice  = price - discount;

      card.dataset.variantId     = variantId;
      card.dataset.originalPrice = price;
      card.dataset.finalPrice    = finalPrice;

      const salePriceEl = card.querySelector('.bundle-section__sale-price');
      const origPriceEl = card.querySelector('.bundle-section__original-price');
      if (salePriceEl) salePriceEl.textContent = this.formatMoney(finalPrice);
      if (origPriceEl) origPriceEl.textContent  = this.formatMoney(price);

      // Update the savings pill if it exists
      const savingsPill = card.querySelector('.bundle-section__savings-pill');
      if (savingsPill && productDiscount > 0) {
        savingsPill.textContent = 'Save ' + productDiscount + '%';
      }

      this.lineItems[productId] = { 
        variantId, 
        originalPrice: price, 
        finalPrice,
        productDiscount
      };
      this.updateTotals();
    }

    /* --------------------------------------------------
       Recompute and display the bundle total
    -------------------------------------------------- */
    updateTotals() {
      const vals     = Object.values(this.lineItems);
      const origTotal = vals.reduce((s, i) => s + (i.originalPrice || 0), 0);
      const saleTotal = vals.reduce((s, i) => s + (i.finalPrice    || 0), 0);
      const savings   = origTotal - saleTotal;

      if (this.totalOrigEl) this.totalOrigEl.textContent = vals.length ? this.formatMoney(origTotal) : '';
      if (this.totalSaleEl) this.totalSaleEl.textContent = vals.length ? this.formatMoney(saleTotal) : '';
      if (this.savingsEl)   this.savingsEl.textContent   = vals.length && savings > 0
        ? 'You save ' + this.formatMoney(savings)
        : '';
    }

    /* --------------------------------------------------
       Update cart item count in Dawn's header bubble
    -------------------------------------------------- */
    updateCartItemCount() {
      if (typeof jQuery !== 'undefined') {
        jQuery.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
            const cartCount = document.getElementById('cart-icon-bubble');
            if (!cartCount) return;
            
            // Clear existing bubble
            const existingBubble = cartCount.querySelector('.cart-count-bubble');
            if (existingBubble) {
              existingBubble.remove();
            }
            
            // Create new bubble
            const cartCountBubbleHtml = '<div class="cart-count-bubble"><span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') +'</span></div>';
            const cartCountBubbleElement = document.createElement('div');
            cartCountBubbleElement.innerHTML = cartCountBubbleHtml;
            cartCount.appendChild(cartCountBubbleElement.firstChild);
          },
          error: function(XMLHttpRequest, textStatus) {
            console.log('Error getting cart count:', textStatus);
          }
        });
      } else {
        // Fallback without jQuery
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCount = document.getElementById('cart-icon-bubble');
            if (!cartCount) return;
            
            const existingBubble = cartCount.querySelector('.cart-count-bubble');
            if (existingBubble) {
              existingBubble.remove();
            }
            
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + '</span>';
            cartCount.appendChild(bubble);
          })
          .catch(err => console.log('Error getting cart count:', err));
      }
    }

    /* --------------------------------------------------
       Update Dawn cart drawer content
    -------------------------------------------------- */
    updateCartDrawer() {
      const updateDrawer = () => {
        const cartDrawerUrl = window.Shopify?.routes?.root 
          ? window.Shopify.routes.root + "?sections=cart-drawer"
          : '/?sections=cart-drawer';
        
        fetch(cartDrawerUrl)
          .then(response => response.json())
          .then(data => {
            if (data['cart-drawer']) {
              const parser = new DOMParser();
              const htmlObject = parser.parseFromString(data['cart-drawer'], 'text/html');
              const cartHtml = htmlObject.querySelector("cart-drawer");
              const mainCart = document.querySelector("cart-drawer");
              
              if (mainCart && cartHtml) {
                // Update cart drawer content
                mainCart.innerHTML = cartHtml.innerHTML;
                
                // Make cart drawer active/open
                mainCart.classList.add("active");
                mainCart.classList.remove('is-empty');
                document.querySelector('body').classList.add('overflow-hidden');
                
                // Attach close event listeners
                this.attachCartDrawerEvents();
                
                // Dispatch event for any other scripts
                document.dispatchEvent(new CustomEvent('cart:drawer:updated', { 
                  bubbles: true 
                }));
              }
            }
          })
          .catch(err => console.log('Error updating cart drawer:', err));
      };
      
      updateDrawer.call(this);
    }

    /* --------------------------------------------------
       Attach event listeners to Dawn cart drawer
    -------------------------------------------------- */
    attachCartDrawerEvents() {
      const closeCartDrawer = document.getElementById('CartDrawer-Overlay');
      const closeButton = document.querySelector('cart-drawer .drawer__close');
      
      const closeDrawer = () => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.classList.remove('active');
          document.querySelector('body').classList.remove('overflow-hidden');
        }
      };
      
      if (closeCartDrawer) {
        closeCartDrawer.removeEventListener('click', closeDrawer);
        closeCartDrawer.addEventListener('click', closeDrawer);
      }
      
      if (closeButton) {
        closeButton.removeEventListener('click', closeDrawer);
        closeButton.addEventListener('click', closeDrawer);
      }
    }

    /* --------------------------------------------------
       Show temporary success message
    -------------------------------------------------- */
    showCartMessage(button) {
      const cartMessage = document.createElement('div');
      cartMessage.classList.add('cart-message');
      cartMessage.textContent = 'Bundle added to cart!';
      cartMessage.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #1d7a3a;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        z-index: 9999;
        animation: slideIn 0.3s ease;
      `;
      
      // Add animation styles if not present
      if (!document.querySelector('#bundle-message-styles')) {
        const style = document.createElement('style');
        style.id = 'bundle-message-styles';
        style.textContent = `
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `;
        document.head.appendChild(style);
      }
      
      document.body.appendChild(cartMessage);
      
      setTimeout(() => {
        cartMessage.style.opacity = '0';
        setTimeout(() => {
          if (cartMessage.parentNode) cartMessage.parentNode.removeChild(cartMessage);
        }, 200);
      }, 3000);
    }

    /* --------------------------------------------------
       Add all bundle items to cart, then apply discount
    -------------------------------------------------- */
    addBundleToCart() {
      if (!this.addBtn) return;

      const items = Object.values(this.lineItems)
        .filter(item => item.variantId)
        .map(item => ({
          id: parseInt(item.variantId, 10), // MUST be integer for Shopify
          quantity: 1,
        }));

      if (!items.length) return;

      this.setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then(r => {
          if (!r.ok) {
            return r.json().then(errData => {
              throw new Error(errData.description || 'Cart add failed');
            });
          }
          return r.json();
        })
        .then(() => {
          // Apply discount code if provided
          if (this.discountCode) {
            fetch('/discount/' + encodeURIComponent(this.discountCode));
          }
          
          // Update cart count in header
          this.updateCartItemCount();
          
          // Update and open Dawn cart drawer
          this.updateCartDrawer();
          
          // Show success message
          this.showCartMessage(this.addBtn);
          
          // Dispatch refresh event for any other components
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          
          // Success feedback on button
          this.setSuccess(true);
          setTimeout(() => this.setSuccess(false), 2800);
        })
        .catch(err => {
          console.error('[Bundle] Add to cart error', err);
          alert(err.message || 'Something went wrong adding the bundle. Please try again.');
        })
        .finally(() => this.setLoading(false));
    }

    /* --------------------------------------------------
       UI helpers
    -------------------------------------------------- */
    setLoading(state) {
      const btnIcon   = this.addBtn.querySelector('.bundle-section__btn-icon');
      const btnText   = this.addBtn.querySelector('.bundle-section__btn-text');
      const btnLoader = this.addBtn.querySelector('.bundle-section__btn-loader');
      this.addBtn.disabled = state;
      if (btnIcon)   btnIcon.style.display   = state ? 'none' : '';
      if (btnText)   btnText.style.display   = state ? 'none' : '';
      if (btnLoader) btnLoader.style.display = state ? 'flex' : 'none';
    }

    setSuccess(state) {
      const btnIcon = this.addBtn.querySelector('.bundle-section__btn-icon');
      const btnText = this.addBtn.querySelector('.bundle-section__btn-text');
      this.addBtn.classList.toggle('success', state);
      if (btnIcon) btnIcon.style.display = state ? 'none' : '';
      if (btnText) {
        btnText.style.display  = '';
        btnText.textContent    = state ? '✓ Added to cart!' : (window.bundleStrings?.cta || 'Add Bundle to Cart');
      }
    }

    formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* --------------------------------------------------
     Boot all bundle sections on the page
  -------------------------------------------------- */
  function bootBundles() {
    document.querySelectorAll('[data-section-id][id^="Bundle-"]').forEach(el => {
      if (!el._bundleInstance) {
        el._bundleInstance = new BundleSection(el);
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', bootBundles);
  
  // Handle Shopify section reloads (like after AJAX pagination)
  document.addEventListener('shopify:section:load', bootBundles);
  
  // Also listen for cart drawer close events to maintain state
  document.addEventListener('cart:drawer:closed', () => {
    // Cart drawer was closed, nothing else needed
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
